import * as React from 'react';
type Props = {
  className?: string;
};
export function Salmon({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Salmon"
      className={className}
    >
      <path
        d="M1.78583 25.4309C4.40648 27.3318 7.15431 29.5145 9.77324 31.4163M1.78583 25.4309C1.78583 25.4309 1.79007 30.6999 1.78577 31.6137C3.01957 32.6155 6.73043 35.6233 9.55399 37.5C11.3406 37.0414 45.5595 24.1826 47.2963 23.0748C47.5757 22.8972 48.2739 22.4515 48.2103 21.98C48.1776 21.7412 47.9575 21.5662 47.6222 21.3722C46.4881 20.7162 45.4392 20.6222 45.4392 20.6222C44.6129 20.548 43.4479 20.2696 41.1178 19.7118C39.1902 19.2506 37.8558 18.7472 37.4826 18.6041C36.1052 18.0747 35.7906 17.817 34.9789 17.4971M1.78583 25.4309C2.45217 24.8162 3.36778 24.1895 4.7125 23.0955C6.21456 21.8757 6.65563 21.6257 7.66331 20.7782C9.9194 18.8816 9.81021 18.3601 11.5049 16.8997C13.7403 14.9713 15.9809 14.1118 17.1253 13.6842C18.4769 13.1781 20.2636 12.5264 22.6521 12.5014C24.7663 12.4781 26.3801 12.7436 28.1333 13.5419C31.6395 15.1368 32.1622 16.4023 34.9789 17.4971M9.77324 31.4163C11.2558 30.622 12.6522 29.6755 13.9398 28.5921C14.8026 27.8684 15.6113 27.0821 16.3593 26.2395C17.4237 25.0266 17.7065 24.4231 18.5001 23.3921C18.7116 23.1162 20.1054 21.3256 22.0537 19.8705C22.9994 19.1653 25.6192 17.2601 29.4857 16.9032C30.6043 16.7997 32.7185 16.604 34.9789 17.4971M9.77324 31.4163L9.84546 37.5M9.5239 21.1205L14.6827 24.5688M12.9631 17.6722L18.1218 21.1205M16.4022 15.0859L20.7012 17.6722M21.561 14.2238L24.1404 15.0859"
        stroke="currentColor"
        strokeWidth={0.962968}
      />
    </svg>
  );
}
